import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'Why is my tax assessment higher than market value?',
    answer:
      "County appraisal districts often use mass appraisal techniques that don't account for specific property issues or recent market conditions. They may use outdated data or comparable properties that aren't truly similar to yours. Additionally, county assessors have an incentive to assess properties at higher values to increase tax revenue.",
  },
  {
    question: 'What happens after I appeal?',
    answer:
      "After filing an appeal, you'll typically receive a hearing date with your county's appraisal review board. You'll present evidence supporting your claim of a lower value. If successful, your property's assessed value may be reduced, resulting in lower property taxes for that year.",
  },
  {
    question: 'Is there a deadline to protest property taxes?',
    answer:
      "Yes, most counties have strict deadlines for filing property tax appeals, typically 30 days after receiving your notice of appraised value. Missing this deadline usually means you'll have to wait until next year to protest. Check with your specific county for exact deadlines.",
  },
  {
    question: 'What evidence do I need to gather for my appeal?',
    answer:
      "Effective evidence includes recent comparable sales in your area, photos of property defects that may lower value, independent appraisals, repair estimates, and any documents showing factors that negatively impact your property's value.",
  },
  {
    question: 'Can I appeal my taxes every year?',
    answer:
      "Yes, you have the right to appeal your property tax assessment annually, regardless of previous appeal outcomes. Market conditions change, and your property's fair market value may fluctuate year to year.",
  },
];

const Faq = () => {
  return (
    <div className="w-full max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-6 text-center text-tax-deepBlue">
        Frequently Asked Questions
      </h2>
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="border-tax-borderGray"
          >
            <AccordionTrigger className="text-left font-medium text-tax-deepBlue">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-tax-neutralGray">
              <p>{faq.answer}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default Faq;
